
<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>AOKI CM</h3>
      <span>Photoshop/Illustrator</span>
    </fade-in-top-title>
    <div class="container container-work">
      <fade-in-main>
        <div class="cm-movie">
          <youtube
          :video-id="videoId"
          ref="youtube"
          @playing="playing"/>
        </div>
      </fade-in-main>
      <work-contents-text-me
      webSiteText="前職で携わった作品「AOKI： 礼服」CMです。"
      webSiteTextContentsFirst="制作時は、商品のイメージや映像の背景など、監督(ディレクター)と意見を交えながら、テロップを制作しました。"
      webSiteTextContentsSecound="以下、テロップ箇所になります。"/>
      <div class="work-contents-wrapper">
        <work-contents-block>
          <img src="@/assets/images/workContents07-01.png" alt="" class="img-cm">
        </work-contents-block>
        <work-contents-block>
          <img src="@/assets/images/workContents07-02.png" alt="" class="img-cm">
        </work-contents-block>
      </div>
    </div>
    <router-link to="/work/workContents06">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents01">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>



<script>
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTextMe from '@/components/WorkContentsTextMe.vue';
import WorkContentsBlock from '@/components/WorkContentsBlock.vue';
import WorkSlideLeft from '@/components/WorkSlideLeft.vue';
import WorkSlideRight from '@/components/WorkSlideRight.vue';

export default {
  data() {
    return {
      videoId: '-s5U-Rhlueg'
    }
  },
  components: {
    FadeInMain,
    FadeInTopTitle,
    WorkContentsTextMe,
    WorkContentsBlock,
    WorkSlideLeft,
    WorkSlideRight
  },
  methods: {
    playing() {
      console.log("再生中");
    }
  }
}
</script>

<style lang="scss" scoped>

.work-contents-wrapper {
  background-color : #fff;
}

.work-contents-07 {
  margin: 100px auto;
}

.img-cm {
  width: 80%;
}

.gif {
  position: relative;
  margin-top: 100px;
  .play-circle {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: .5;
    cursor: pointer;
  }
}

iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
</style>